<template>
  <div class="onboarding-card text-center">
    <p class="ob-subtitle">¡Vamos a construir tu sueño!</p>
    <p class="ob-text">
      En un lapso no mayor a 24 hrs recibirás las 3 mejores opciones para ti
    </p>

    <button type="button" class="btn ob-btn-primary w-100 mt-4" @click="$emit('nuevo-sueno')">
      CREAR UN NUEVO SUEÑO
    </button>

    <button type="button" class="btn ob-btn-primary w-100 mt-3" @click="$emit('conocer-catalogo')">
      CONOCER EL CATALOGO
    </button>

    <p class="ob-footer">GRUPO TERRAZON SAPI DE CV</p>
  </div>
</template>

<script>
export default {
  name: 'PantallaResultado',
};
</script>
